import { SearchChatThreadsReq_OrderBy } from "gen/search/service/service_pb"
import { UUID } from "shared-ts/classes/uuid"
import { SortOrder } from "shared-ts/hooks/useSort/helpers"
import { WebUrl } from "shared-web/lib/webUrl"

const defaultMessagesQuery = {
  sort: SearchChatThreadsReq_OrderBy.LAST_ACTIVITY_AT.toString(),
  order: SortOrder.Descending,
}

export function message(id: UUID): WebUrl {
  return {
    pathname: `/pos/customers/messages/${id.toString()}`,
    query: defaultMessagesQuery,
  }
}

export const messages: WebUrl = {
  pathname: "/pos/customers/messages",
  query: defaultMessagesQuery,
}
